var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklistActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_451_271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15C13.8801 14.9984 14.9984 13.8801 15 12.5V2.50001C14.9984 1.11994 13.8801 0.00159469 12.5 0H2.50001C1.11994 0.00159469 0.00159469 1.11994 0 2.50001V12.5C0.00159469 13.8801 1.11994 14.9984 2.50001 15L12.5 15ZM1.24999 12.5V2.50001C1.25066 1.80993 1.80993 1.25068 2.49999 1.25002H12.5C13.1901 1.25068 13.7493 1.80995 13.75 2.50001V12.5C13.7493 13.1901 13.19 13.7493 12.5 13.75H2.50001C1.80993 13.7493 1.25068 13.1901 1.24999 12.5Z",
    fill: "#78A22F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37498 11.875C4.54077 11.8752 4.6998 11.8093 4.81688 11.6919L7.31689 9.19191C7.55786 8.94475 7.55283 8.54905 7.30568 8.3081C7.06294 8.07145 6.67582 8.07145 6.43309 8.3081L4.375 10.3662L3.56691 9.55812C3.31976 9.31715 2.92405 9.32218 2.6831 9.56933C2.44645 9.81207 2.44645 10.1992 2.6831 10.442L3.9331 11.6919C4.05015 11.8093 4.20918 11.8752 4.37498 11.875Z",
    fill: "#78A22F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37495 6.87502C4.54075 6.87522 4.69978 6.80932 4.81685 6.69192L7.31686 4.19191C7.56402 3.95094 7.56902 3.55526 7.32808 3.30811C7.0871 3.06096 6.69142 3.05595 6.44427 3.2969C6.44049 3.30058 6.43676 3.30433 6.43306 3.30811L4.37497 5.36624L3.56688 4.55813C3.32591 4.31097 2.93023 4.30597 2.68308 4.54691C2.43593 4.78789 2.43092 5.18357 2.67187 5.43072C2.67555 5.4345 2.6793 5.43823 2.68308 5.44193L3.93307 6.69192C4.05012 6.80932 4.20915 6.87519 4.37495 6.87502Z",
    fill: "#78A22F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 11.25C12.2202 11.25 12.5 10.9702 12.5 10.625C12.5 10.2799 12.2202 10 11.875 10H8.75C8.40481 10 8.125 10.2799 8.125 10.625C8.125 10.9702 8.40483 11.25 8.75 11.25H11.875Z",
    fill: "#78A22F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 6.24999C12.2202 6.24999 12.5 5.97016 12.5 5.625C12.5 5.27983 12.2202 5 11.875 5H8.75C8.40481 5 8.125 5.27983 8.125 5.625C8.125 5.97016 8.40483 6.24999 8.75 6.24999H11.875Z",
    fill: "#78A22F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_451_271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistActiveIcon);
export default __webpack_public_path__ + "static/media/checklist-active-icon.24dc21c795e19a11d42f90618f575da2.svg";
export { ForwardRef as ReactComponent };